export default "__VITE_ASSET__bbZubESv__"